// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dB2O","label":"styles_label__DAm_x"};